import { HsObservable } from './observable.class';

export class HsSubject<T> extends HsObservable<T> {
  public next(value: T): void {
    for (const subscriber of this.subscribers) {
      subscriber(value);
    }
  }
}
